export default __webpack_public_path__ + "static/media/favicon.c4567b92.ico";